export enum RolesList {
  LONE = "L1",//plant sales
  LTWO="L2",
  LTHREE="L3",
  LFOUR="L4",//admin
  LFIVE="L5"//Head office sales
}
